/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Component, Inject, Input, TemplateRef, ViewChild} from '@angular/core';
import {IF_ACTIVE_ID, IfActiveService} from '../../utils/conditional/if-active.service';
import {AriaService} from './aria-service';

let /** @type {?} */ nbTabContentComponents: number = 0;
export class TabContent {
     templateRef: TemplateRef<TabContent>;
/**
 * @param {?} ifActiveService
 * @param {?} id
 * @param {?} ariaService
 */
constructor(public ifActiveService: IfActiveService,
public id: number,
private ariaService: AriaService) {
        if (!this.tabContentId) {
            this.tabContentId = "clr-tab-content-" + (nbTabContentComponents++);
        }
    }
/**
 * @return {?}
 */
get ariaLabelledBy(): string {
        return this.ariaService.ariaLabelledBy;
    }
/**
 * @return {?}
 */
get tabContentId(): string {
        return this.ariaService.ariaControls;
    }
/**
 * @param {?} id
 * @return {?}
 */
set tabContentId(id: string) {
        this.ariaService.ariaControls = id;
    }
/**
 * @return {?}
 */
get active() {
        return this.ifActiveService.current === this.id;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-tab-content",
    template: `
        <ng-content></ng-content>
    `,
    host: {
        "[id]": "tabContentId",
        "[attr.aria-labelledby]": "ariaLabelledBy",
        "[attr.aria-hidden]": "!active",
        "[attr.data-hidden]": "!active",
        "role": "tabpanel"
    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: IfActiveService, },
{type: undefined, decorators: [{ type: Inject, args: [IF_ACTIVE_ID, ] }, ]},
{type: AriaService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ["tabContentProjectedRef", ] },],
'tabContentId': [{ type: Input, args: ["id", ] },],
};
}

function TabContent_tsickle_Closure_declarations() {
/** @type {?} */
TabContent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TabContent.ctorParameters;
/** @type {?} */
TabContent.propDecorators;
/** @type {?} */
TabContent.prototype.templateRef;
/** @type {?} */
TabContent.prototype.ifActiveService;
/** @type {?} */
TabContent.prototype.id;
/** @type {?} */
TabContent.prototype.ariaService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
